import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  
  // Die Navbar wird auf der Hauptseite und auf der Danke-Seite komplett ausgeblendet
  const isHiddenPage = 
    location.pathname === '/geschaeftsfuehrer-video' || 
    location.pathname === '/' || 
    location.pathname === '/geschaeftsfuehrer-video/thank-you';

  if (isHiddenPage) {
    return null;
  }

  return (
    <nav className="w-full border-b border-brand-border/50 bg-[#06080c]/80 backdrop-blur-md fixed top-0 left-0 right-0 z-50">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/geschaeftsfuehrer-video" className="flex items-center">
          <img 
            src="https://cloud-1de12d.becdn.net/media/original/c72bc1b1932577422f382e4ca0360d27.png" 
            alt="R&R Logo" 
            className="h-8 hover:opacity-80 transition-opacity" 
          />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;